import { useMemo, useRef } from 'react';

import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { IndentContainer } from '@r1-frontend/ui-react/experimental/containers';

import { IFaqArticle } from '~/src/api/content/faq';

import * as ST from './styled';

interface IProps {
    faq?: IFaqArticle[],
}

type TRequiredFaqArticle = Required<Pick<IFaqArticle, 'faq_id' | 'question' | 'answer'>>;

const FaqBlock = ({ faq = [] }: IProps): JSX.Element | null => {
    const accordionTitleRef = useRef<HTMLDivElement | null>(null);

    const preparedFaq = useMemo(
        () => faq.reduce((acc: TRequiredFaqArticle[], item) => {
            const { faq_id, question, answer } = item;

            if (faq_id && question && answer) {
                acc.push({ faq_id, question, answer });
            }

            return acc;
        }, []),
        [faq],
    );

    if (!preparedFaq.length) {
        return null;
    }

    return (
        <>
            <IndentContainer $united={[40, 0, 32]}>
                <H3
                    $withIndent={false}
                    id={'faq'}
                    ref={accordionTitleRef}
                >
                    Частые вопросы
                </H3>
            </IndentContainer>
            <ST.FaqContainer>
                {preparedFaq.map(({ faq_id, question, answer }) => (
                    <ST.SAccordion key={faq_id} title={question} data-test='question'>
                        <ST.AccordionContent dangerouslySetInnerHTML={{ __html: answer }}/>
                    </ST.SAccordion>
                ))}
            </ST.FaqContainer>
        </>
    );
};

export default FaqBlock;
